<template>
  <div class="flex items-center">
    <router-link :to="url" @click.stop.prevent class="text-inherit font-bold hover:text-primary">{{ params.value }}</router-link>
  </div>
</template>

<script>
export default {
  name: 'CellRendererLink',
  data() {
    return {
      data: {},
      urlMapping: {
        bill: `/billings/view`,
        wo: `/orders/view`,
      }
    }
  },
  computed: {
    url () {
      return `${this.urlMapping[this.data.approval.type]}/${this.data.approval.reference_id}`;
    }
  },
  created() {
    this.data = this.params.data;
  }
}
</script>
